import { render, staticRenderFns } from "./PeopleBoard.vue?vue&type=template&id=4ddb4142&scoped=true&"
import script from "./PeopleBoard.vue?vue&type=script&lang=js&"
export * from "./PeopleBoard.vue?vue&type=script&lang=js&"
import style0 from "./PeopleBoard.vue?vue&type=style&index=0&id=4ddb4142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb4142",
  null
  
)

export default component.exports